import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Logo from '../components/Logo';
import { useApp } from '../context/AppContext';
import { adminLogin, adminMe } from '../api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const Login = () => {
  const { t } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Staff Login | GOBRA Capital Real Estate';
    adminMe().then(() => navigate('/admin')).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await adminLogin(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 py-24 bg-gobra-sand/50">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gobra-sand p-8 shadow-[0_30px_60px_-30px_rgba(47,61,76,0.4)]">
        <div className="flex justify-center mb-6"><Logo variant="dark" /></div>
        <div className="flex items-center justify-center gap-2 text-gobra-slate mb-6">
          <Lock className="h-4 w-4 text-gobra-terracotta" />
          <h1 className="font-title text-xl font-semibold">Staff Login</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-gobra-slate">{t('email')}</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
          </div>
          <div>
            <Label className="text-gobra-slate">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
          </div>
          {error && <p className="text-destructive text-sm">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-gobra-green hover:bg-gobra-green-dark text-white rounded-full py-6">
            {loading ? 'Signing in...' : t('login')}
          </Button>
        </form>
        <p className="text-xs text-center text-muted-foreground mt-5">Access is by invitation only. Accounts are created by the administrator.</p>
      </div>
    </main>
  );
};

export default Login;
